import React from "react";

const DataAnalyticsLayout = () => {
    return (
        <div className="bg-white">

            {/* ================= HERO ================= */}
            <section
                className="relative h-[520px] flex items-center text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(rgba(3,20,40,.8), rgba(3,20,40,.8)), url(/images/dataanalyst/hero.jpg)",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="relative w-full px-6 md:px-16 lg:px-24 py-24 text-white text-left">
                    <span className="uppercase text-sm tracking-wide text-orange-400">
                        Services
                    </span>
                    <h1 className="text-4xl md:text-5xl font-bold mt-3 mb-4">
                        Data & Analytics
                    </h1>
                    <p className="max-w-2xl text-lg text-gray-200 mb-6">
                        Unlock growth through data at the speed of business.
                    </p>
                    <button className="bg-orange-500 hover:bg-orange-600 px-6 py-3 rounded-md font-semibold">
                        Consult Our Experts
                    </button>
                </div>
            </section>

            {/* ================= RECOGNITION ================= */}
            <section className="py-14 border-b">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-10">
                    <div>
                        <h3 className="text-xl font-semibold mb-2">
                            TechSPR Named a Leader in ISG Provider Lens™
                        </h3>
                        <p className="text-gray-600">
                            For Data, Analytics & AI Advisory Services.
                        </p>
                    </div>
                    <div className="flex items-center justify-center">
                        <img
                            src="/images/dataanalyst/gartner.svg"
                            alt="Gartner"
                            className="h-10"
                        />
                    </div>
                </div>
            </section>

            {/* ================= INTRO CONTENT ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-12">
                    <div>
                        <p className="text-gray-700 mb-4">
                            We help organizations become data-driven. We enable your enterprise
                            to unlock insights, accelerate innovation, and create measurable
                            business value through advanced analytics and AI.
                        </p>
                        <p className="text-gray-700">
                            Our end-to-end analytics capabilities span advisory, engineering,
                            modernization, and governance—helping you build trusted, scalable
                            data ecosystems.
                        </p>
                    </div>

                    <div className="rounded-xl overflow-hidden shadow-lg">
                        <img
                            src="/images/dataanalyst/dashboard.png"
                            alt="Analytics Dashboard"
                        />
                    </div>
                </div>
            </section>

            {/* ================= PARTNER CARDS ================= */}
            <section className="py-16 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6 grid md:grid-cols-2 gap-8">
                    <div className="bg-white rounded-xl shadow p-6">
                        <h4 className="font-semibold mb-2">
                            TechSPR is now a Premier Snowflake Services Partner
                        </h4>
                        <p className="text-sm text-gray-600 mb-4">
                            Driving cloud-native analytics and data modernization.
                        </p>
                        <button className="text-orange-500 font-semibold">
                            Learn more →
                        </button>
                    </div>

                    <div className="bg-orange-50 rounded-xl shadow p-6">
                        <h4 className="font-semibold mb-2">
                            Select Status Consulting Partner to Databricks
                        </h4>
                        <p className="text-sm text-gray-600 mb-4">
                            Accelerating enterprise analytics with Lakehouse architecture.
                        </p>
                        <button className="text-orange-500 font-semibold">
                            Learn more →
                        </button>
                    </div>
                </div>
            </section>

            {/* ================= ADVISORY ================= */}
            <section className="py-24 bg-gray-50">
                <div className="max-w-7xl mx-auto px-6">
                    <div className="grid md:grid-cols-3 gap-12 items-start">

                        {/* Left – Primary Content */}
                        <div className="md:col-span-2">
                            <span className="inline-block text-sm font-semibold text-orange-500 mb-3">
                                Advisory Services
                            </span>

                            <h3 className="text-3xl md:text-4xl font-bold mb-4 leading-tight">
                                Data & Analytics Advisory
                            </h3>

                            <p className="text-gray-600 text-lg max-w-2xl mb-6">
                                Build a future-ready data and analytics strategy that drives measurable
                                business outcomes, innovation, and long-term growth.
                            </p>

                            <button className="inline-flex items-center gap-2 text-orange-500 font-semibold group">
                                Learn more
                                <span className="transition-transform group-hover:translate-x-1">
                                    →
                                </span>
                            </button>
                        </div>

                        {/* Right – Offerings Card */}
                        <div className="bg-white rounded-2xl shadow-sm p-8">
                            <h4 className="text-lg font-semibold mb-4">
                                Our Offerings
                            </h4>

                            <ul className="space-y-3 text-gray-600 text-sm">
                                <li className="flex items-start gap-3">
                                    <span className="text-orange-500 font-bold">•</span>
                                    Data Strategy & Roadmap
                                </li>
                                <li className="flex items-start gap-3">
                                    <span className="text-orange-500 font-bold">•</span>
                                    Modern Data Architecture
                                </li>
                                <li className="flex items-start gap-3">
                                    <span className="text-orange-500 font-bold">•</span>
                                    Analytics & AI Platforms
                                </li>
                                <li className="flex items-start gap-3">
                                    <span className="text-orange-500 font-bold">•</span>
                                    Data Governance & Security
                                </li>
                            </ul>
                        </div>

                    </div>
                </div>
            </section>


            {/* ================= EXPERIENCE HUB ================= */}
            <section
                className="py-24 text-white"
                style={{
                    backgroundImage:
                        "linear-gradient(120deg, #020617, #020617)",
                }}
            >
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">
                        Data Experience Hub
                    </h2>

                    <div className="grid md:grid-cols-4 gap-6">
                        {[
                            "Decision & Data Science",
                            "Business Intelligence & Reporting",
                            "Data Integration & Modernization",
                            "Data Quality & Governance",
                        ].map((item) => (
                            <div key={item} className="bg-white/10 rounded-xl p-6">
                                <h4 className="font-semibold mb-2">{item}</h4>
                                <button className="text-orange-400 text-sm">
                                    Learn more →
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* ================= CLIENT SUCCESS ================= */}
            <section className="py-24 bg-slate-900 text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-4xl font-bold mb-12">Client Success</h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                img: "/images/dataanalyst/cs1.jpg",
                                title: "Data-Driven Enterprise",
                                text: "Modernized legacy data systems to enable faster, smarter decisions.",
                                cta: "Read the story →",
                            },
                            {
                                img: "/images/applicationdevelopment/client2.jpg",
                                title: "Cloud-First Organization",
                                text: "Reduced infrastructure costs and improved system scalability.",
                                cta: "View case study →",
                            },
                            {
                                img: "/images/applicationdevelopment/client3.jpg",
                                title: "AI-Powered Business",
                                text: "Improved customer retention using predictive analytics.",
                                cta: "Explore success →",
                            },
                        ].map((item, i) => (
                            <div
                                key={i}
                                className="bg-slate-800 rounded-2xl overflow-hidden"
                            >
                                <img
                                    src={item.img}
                                    alt={item.title}
                                    className="w-full h-48 object-cover"
                                    loading="lazy"
                                />

                                <div className="p-6">
                                    <h3 className="font-semibold mb-2 text-lg">
                                        {item.title}
                                    </h3>

                                    <p className="text-slate-300 text-sm">
                                        {item.text}
                                    </p>

                                    <button className="text-orange-400 mt-4 font-medium">
                                        {item.cta}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>



            {/* ================= NEWS & INSIGHTS ================= */}
            <section className="py-20 bg-[#020617] text-white">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-10">News & Insights</h2>

                    <div className="grid md:grid-cols-3 gap-8">
                        {[
                            {
                                image:
                                    "https://images.unsplash.com/photo-1504384308090-c894fdcc538d",
                                title: "Enterprise data strategy in the age of generative AI",
                                cta: "Read Article →",
                            },
                            {
                                image:
                                    "https://images.unsplash.com/photo-1518770660439-4636190af475",
                                title: "How cloud-native platforms are reshaping IT operations",
                                cta: "Read Insight →",
                            },
                            {
                                image:
                                    "https://images.unsplash.com/photo-1551288049-bebda4e38f71",
                                title: "From dashboards to decisions: the future of analytics",
                                cta: "Explore Trends →",
                            },
                        ].map((item, index) => (
                            <div
                                key={index}
                                className="bg-white text-black rounded-xl overflow-hidden shadow hover:shadow-lg transition"
                            >
                                <img
                                    src={item.image}
                                    alt="Insight"
                                    className="w-full h-48 object-cover"
                                />

                                <div className="p-5">
                                    <h4 className="font-semibold mb-3 text-lg">
                                        {item.title}
                                    </h4>

                                    <button className="text-orange-500 font-semibold hover:underline">
                                        {item.cta}
                                    </button>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>


            {/* ================= CONTACT ================= */}
            <section className="py-20">
                <div className="max-w-7xl mx-auto px-6">
                    <h2 className="text-3xl font-bold mb-8">Contact Us</h2>
                    <form className="grid md:grid-cols-2 gap-6">
                        <input className="border p-3 rounded" placeholder="First name" />
                        <input className="border p-3 rounded" placeholder="Last name" />
                        <input className="border p-3 rounded" placeholder="Work email" />
                        <input className="border p-3 rounded" placeholder="Company" />
                        <textarea
                            className="border p-3 rounded md:col-span-2"
                            placeholder="How can we help?"
                            rows="4"
                        />
                        <button className="bg-orange-500 text-white px-6 py-3 rounded-md font-semibold">
                            Submit
                        </button>
                    </form>
                </div>
            </section>

        </div>
    );
};

export default DataAnalyticsLayout;
